import { readDevCookie, switchPath, MASTER } from "./versions"
import { waitForSync } from "../services/sync.service"

// Dentro l'app: su quale versione dell'app dev si sta girando. Il cookie lo
// scrive `middleware.js`, e c'è solo lì: altrove (la produzione, il locale,
// una preview aperta dal suo indirizzo) è null.
export const currentDevVersion = () => {
	try {
		return readDevCookie(document.cookie)
	} catch {
		return null
	}
}

export const devVersionLabel = id => (id === MASTER ? "DEV" : `#${id}`)

// Prima di cambiare si lascia partire quello che è da inviare, ma non si
// aspetta per sempre: le scritture in coda sopravvivono comunque al cambio.
export const switchDevVersion = async id => {
	await waitForSync(5000)
	window.location.assign(switchPath(id))
}
